<template>
  <div>
    <div class="empty-state" v-show="loading">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
    <div class="empty-state" v-show="logs.length === 0 && !loading">
      <i class="fa fa-clipboard-list fa-4x"></i>
      <span>{{ $t('rsvpDetails.activityLogs.emptyState') }}</span>
    </div>

    <div v-for="(log, i) in logs" :key="i" @click="log.collapsed = !log.collapsed" :class="{'log':true, 'collapsed':log.collapsed}">
      <div class="minimize">
        <div class="icon-display">
          <i class="fa fa-plus-circle" v-if="!log.collapsed"></i>
          <i class="fa fa-minus-circle" v-else></i>
        </div>
        <div class="log-display">
          <span>{{dateSplit(log.created).date}} {{dateSplit(log.created).time}}  <p v-html="displayAction(log)"></p></span>
        </div>
      </div>

      <transition name="slide-down">
        <div v-show="log.collapsed" class="log-item">
          <div class="icon-display"></div>
          <div class="log-display">
           <span class="log-details" v-html="displayLog(log)"></span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import ApiCorporateLogs from '@/modules/api/corporate/logs'
import moment from 'moment'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'corporate-logs',
  props: ['corporateId'],
  data() {
    return {
    }
  },
  computed: {
    logs () { return this.$store.state.corporate.logs.list },
    loading () { return this.$store.state.corporate.logs.loading }
  },
  watch: {
    corporateId: function (value) {
      this.init()
    }
  },
  methods: {
    init () {
      let self = this
      self.$store.commit('corporate/setLoadingLogs', true)
      self.$store.commit('corporate/resetLogs')
      self.$store.commit('corporate/setCorporateLogsCurrentPage', 1)
      ApiCorporateLogs.getLogs(self, self.corporateId, function (res) {
        self.$store.commit('corporate/setLoadingLogs', false)
      })
    },
    dateSplit (data) {
      let date =  moment(data, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, true))
      return {
        date: date.format('MM/DD/YYYY'),
        time: date.format(featureToggle.timeFormat(this, true))
      }
    },
    displayAction (data) {
      let self = this
      switch (data.action) {
        default: return `<b>${data.action}</b>`
        case "create": return '<b>Admin created an account</b>'
        case "change_password": return '<b>Admin changed the password</b>'
        case "create_invoice": return '<b>Admin created an invoice</b>'
        case "update_invoice": return '<b>Admin updated an invoice</b>'
        case "activate": return '<b>Admin activated the account</b>'
        case "deactivate": return '<b>Admin deactivated the account</b>'
        case "update": return '<b>Admin made an update</b>'
      }
    },
    displayLog (data) {
      let self = this
      let createdTime = self.dateSplit(data.created).date + ' ' + self.dateSplit(data.created).time
      let admin = data.admin ? '<br/><div>Admin ID: <b>'+ data.admin.id +
      '</b></div><div>Admin Name: <b>'+ data.admin.name +
      '</b></div> <div>Admin Email: <b>'+ data.admin.email + '</b></div>' : ''

      switch (data.action) {
        default: return admin

        case "update":
          let fields = []
          if(data.fields) {
            data.fields.forEach((log) => {
              fields.push(
                '<br/><div><b>'+ self.labelFormat(log.field) +'</b></div><div>'+ self.valueFormat(log.field, log.old) +' <i class="fas fa-chevron-right"></i> <b>'+ self.valueFormat(log.field, log.new)+'</b></div>'
              )
            })
            return admin + fields.join('')
          } else {
            return admin
          }

        case "create_invoice":
        case "update_invoice":
          let status =
          '<br/><div>Invoice ID: <b>'+ data.invoiceId +
          '</b></div><div>Status: <b>'+ self.labelFormat(data.status) +
          '</b></div> <div>Start Date: <b>'+ self.labelFormat(data.startDate) +
          '</b></div> <div>End Date: <b>'+ self.labelFormat(data.endDate) +
          '</b></div> <div>Due Date: <b>'+ self.labelFormat(data.dueDate) +
          '</b></div> <div><a href="/#/corporate/'+self.corporateId+'/invoice/'+data.invoiceId+'" target="_blank">View File</a></div>'
          return admin + status

      }
    },
    labelFormat (field) {
      switch (field) {
        default: return field.replace(/^\w/, c => c.toUpperCase())
        case "contactEmail" : return "Email"
        case "contactPhone" : return "Phone"
        case "billingAddress1" : return "Address1"
        case "billingAddress2" : return "Address2"
        case "billingCity" : return "City"
        case "billingState" : return "State"
        case "billingZip" : return "Zip"
        case "billingCountry" : return "Country"
        case "logoUrl" : return "Logo URL"
      }
    },
    valueFormat (field, value) {
      if (!value) { return 'none' }
      return value
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ccc;
    text-shadow:0 0 5px rgba(255,255,255, 1);
  }
}

.log{
  border: 1px solid #ddd;
  width: 100%;
  max-height:auto;
  padding: 10px;
  background: #fafafa;
  overflow: hidden;
  transition: all .35s ease-in-out;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover { background: #fff8dc; }

  &.collapsed{
    padding: 10px;
    background: #fff8dc;
    }
  .log-item {
    padding-left: 15px;
    transform-origin: top center;

    .icon-display {
      float: left;
      width: 5%;
        i {
        font-size: 11px;
        color: #666;
        }
    }

    .log-display {
      float: left;
      width: 95%;
      p {
        margin: 0;
      }
    }

    .log-details {
      font-size: 11px;
      color: #666;

        /deep/ br {
          content: 'a';
          display: block;
          margin-bottom: 15px;
      }
    }
  }
  .minimize {
    font-size: 11px;
    color: #666;
    content: "";
    // display: table;
    clear: both;

    .icon-display {
      float: left;
      width: 5%;
      i {
        font-size: 11px;
        color: #666;
      }
    }

    .log-display {
      float: left;
      width: 95%;
      p {
        margin: 0;
      }
    }

  }

  .field{
    font-size: 12px;
    padding: 4px 0 4px 10px;

    span{ display: inline-block; }
    .label{
      font-weight: 600;
      margin-right: 10px;
      color: #28b560;
      display: block;
    }
    i{
      margin: 0 5px;
      color: #0D79F2;
    }
    .old{
      color: #d0d0d0;
      &.last{ display:none; }
    }
    .new{
      color: #555;
      font-weight: 600;
    }

    &.no-arrow{
      i{ display: none; }
      .new{ display: block; }
      .old.first{ display: none;}
      .old.last{
        display: block;
        font-size: 12px;
      }
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .2s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/CorporateLogs.vue